import * as _ from 'lodash'
import { IBusinessObject, IBusinessObjectCreateLoadOptions } from "../PA.Core/PA.Core.IF.BO";
import { IMessageProvider, IProgressProvider, MessageType } from "../PA.Core/PA.Core.IF.Basic";
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'

import {PAEnvironment} from "../PA.Core/PAEnvironment";
import { ErrorMessage_restate, InfoMessage_restate } from "../PA.Core/Basic/MessageUtils";
import {
    esWB_ScnPlan
} from "../PA.Core/PAdbSchema";
import { TextUtils } from "../PA.Core/Basic/Text";
import { WB_ScenarioPlanRow } from "../PA.Core/PAdbSchemaRows"

let wbIdSequenceVal = 77000000

export interface IScenarioPlanCompareLoadOptions extends  IBusinessObjectCreateLoadOptions {
    wbScnPlanIds?: number[]
}

export class ScenarioPlanCompareBO
    implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: IScenarioPlanCompareLoadOptions;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;


    constructor(options?: IScenarioPlanCompareLoadOptions) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Scenario Plan Compare'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = undefined;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);


        this.IScenarioPlanCompare_init();
        this.wbScenarioPlanIds = options?.wbScnPlanIds || []
    }



    //<editor-fold desc = "IBusinessObject operations">

    async LoadNew(options?: IScenarioPlanCompareLoadOptions): Promise<IBusinessObject> {
        const self = this;

        self.LoadProgressProvider.start("Creating ScenarioPlan Compare");
        let rv = self._OnLoadComplete = (async () => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (_.isEmpty(self.dbContext)) {
                let sError = "Unable to determine dbContext for new Scenario Plan Compare.";
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(sError);

                return self;
            }
            try {
                self.wbScenarioPlanIds = options?.wbScnPlanIds || []
                self.Identity.setAll(self.ScenarioPlanCompareWbId, self.ScenarioPlanCompareId, self.ScenarioPlanCompareName);

                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");


                await self._AfterBoLoadCompleteInternal()

                self.Identity.setAll(self.ScenarioPlanCompareWbId, self.ScenarioPlanCompareId, self.ScenarioPlanCompareName);

                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.finish();
                return self;
            } catch (err) {
                self.LoadProgressProvider.exception(err)
                return self
            }

        })();

        return rv;
    }

    async Load(anId: number, options?: object): Promise<IBusinessObject> {
        const self = this;

        throw "Load not Supported"

    }


    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    async Validate(options?: any): Promise<IBusinessObject> {
        const self = this;

        const mp = self.ValidateMessageProvider
        const pp  = self.ValidateProgressProvider
        mp.clearMessages();
        pp.start("Validating");
        self.ValidateOptions = options || {};
        const initMsgs = self.initMessageProvider.Messages
        mp.addMessages(initMsgs)


        if (mp.countMessages(MessageType.Error) > 0) {
            self._bIsValidated = false;
        } else {
            self._bIsValidated = true;
        }
        pp.finish()
        return self
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;

        self._bIsSaved = false
        throw "Save not Supported"
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }


//Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private async DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        throw "Delete not Supported"

    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    private async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;


        self.LoadProgressProvider.setProgressMessage('ScenarioPlanCompareBO.PostLoad', 'Processing Loaded Data');
        await self.IScenarioPlanCompare_onLoadComplete()

        return
    }


    //</editor-fold>



    //<editor-fold desc = "IScenarioPlanCompare operations">

    private ScenarioPlanCompareWbId: number
    private ScenarioPlanCompareId: string
    private ScenarioPlanCompareName: string
    private initMessageProvider: MessageProvider

    private wbScenarioPlanIds: number[]
    private arrWbScenarioPlanRows: WB_ScenarioPlanRow[]

    private IScenarioPlanCompare_init() {
        //--
        this.ScenarioPlanCompareWbId = 0
        this.ScenarioPlanCompareId = "NA"
        this.ScenarioPlanCompareName = "AS"
        this.initMessageProvider = new MessageProvider()
        this.wbScenarioPlanIds = []
        this.arrWbScenarioPlanRows = []
    }

    private async IScenarioPlanCompare_onLoadComplete(): Promise<void> {
        const self = this
        const opts = self.LoadOptions || {}
        const mp = self.initMessageProvider

        if(self.ScenarioPlanCompareWbId == 0)
            self.ScenarioPlanCompareWbId = wbIdSequenceVal++

        if(!_.isEmpty(self.wbScenarioPlanIds)){
            self.arrWbScenarioPlanRows = <WB_ScenarioPlanRow[]> await self.dbContext.findAll(esWB_ScnPlan, {where: {WB_SCNPLAN_ID: {inq: self.wbScenarioPlanIds}, DELETED_IND: {neq: '1'}}})
        }


        this.ScenarioPlanCompareId = TextUtils.padStart(this.ScenarioPlanCompareWbId.toString(36), 12, '0').toUpperCase()
        this.ScenarioPlanCompareName = `Scenario Compare: ${_.map(self.arrWbScenarioPlanRows,(a) => a.cif.PLAN_ID).join(",")}`



    }

    get WbScnPlanIds(): number[] { return this.wbScenarioPlanIds }

    //</editor-fold>



};

PAEnvironment.registerBusinessObjectClass(ScenarioPlanCompareBO, "ScenarioPlanCompareBO", "Scenario Plan Compare")
